import React from 'react';
import { makeStyles } from "@material-ui/core";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    quizCard: {
        background: '#fff',
        borderBottom: '1px solid #EFF5F4',
        padding: '15px 15px',
        display: 'flex',
        alignItems: 'center',
        cursor: "pointer",
        '& img': {
            width: 50,
            marginRight: 10,
            height: 50
        },
        '& h4': {
            margin: 0,
            fontSize: 14
        },
        '& svg': {
            marginLeft: 'auto',
            fill: '#aaa'
        }
    }
}));
const ExamTopicCard = props => {
    const t = useTranslations();
    const navigate = useNavigate();
    const classes = useStyles();
    function goToExamScreen() {
        navigate('/my-app/exam-topic-screen/exams');
    }
    return (
        <>
          <div className={classes.quizCard} onClick={goToExamScreen}>
            <img src={props.src} alt="" />
            <h4>{props.testName}</h4>
            <ChevronRightIcon />
         </div>
        </>
    );
};
export default ExamTopicCard;